import { api } from "@/lib/api";

const base = "/admin/sync-schedule";
export const getSchedule = () => api.get(base).then((r) => r.data);
export const saveSchedule = (body) => api.put(base, body).then((r) => r.data);
export const schedulePosts = () => api.get(`${base}/posts`).then((r) => r.data);
export const savePostSchedule = (pid, body) => api.put(`${base}/posts/${pid}`, body).then((r) => r.data);

export const fmtInterval = (s) => (s == null ? "—" : s < 60 ? `${s} s` : s % 3600 === 0 ? `${s / 3600} h` : s % 60 === 0 ? `${s / 60} min` : `${Math.floor(s / 60)} min ${s % 60} s`);
